import React from 'react';
import ErrorMessage from './ErrorMessage'

import '../../styles/messages/MusicMessage.css'


export default class MusicMessage extends React.PureComponent{
	constructor(props){
		super(props)
		this.state = {
			audioState: 'stopped',
			visible: Boolean(props.message.status)
		}
	}

	componentDidMount(){
		const {message} = this.props
		if(!this.state.visible){
			this.context.classroomPage.lazyLoads.push({
				el: document.getElementById('message_' + message.id),
				onVisible: () => this.setState({visible: true})
			})
		}
	}
	

	onMusicBoxClick(e){
		if(this.state.audioState === 'stopped'){
			this.context.messageList.onAudioStart(this)
			this.start()
		}else if(this.state.audioState === 'playing'){
			this.context.messageList.onAudioStop(this)
			this.stop()
		}
	}

	start(){
		this.setState({audioState: 'playing'})
	}

	stop(){
		this.setState({audioState: 'stopped'})
	}

	isInViewport(){
		const {message} = this.props
		const el = document.getElementById('message_' + message.id)
        if (el === null)
            return false
		const rect = el.getBoundingClientRect()
        const page = document.getElementById('page').getBoundingClientRect()
		const isVisible = rect.bottom > page.top && rect.top < screen.height
		return isVisible
	}

	render(){
		try {
            const {message} = this.props
            return (
				<div className="music-content">
                    {this.state.visible &&
					<div className="wrap-music">
						<div className="bg">
							<img src={message.meta.thumb_url} alt="" />
						</div>
						<div className="front">
							<div className="left-side">
								<p className="songname">{message.meta.songname}</p>
								<p className="singername">{message.meta.singername}</p>
							</div>
							<div className="right-side"
								 style={{backgroundImage: `url('${message.meta.thumb_url}')`}}
								 onClick={this.onMusicBoxClick.bind(this)}>
                                {this.state.audioState === 'stopped' ?
									<i className="iconfont icon-bofang-copy"></i>
                                    :
									<i className="iconfont icon-tingzhi"></i>
                                }
							</div>
						</div>
					</div>
                    }
				</div>
            )
		} catch(e) {
			return <ErrorMessage/>
		}
	}
}


MusicMessage.contextTypes = {
	messageList: React.PropTypes.object,
  	classroomPage: React.PropTypes.object
};




// WEBPACK FOOTER //
// ./src/components/messages/MusicMessage.js